import { useWorkoutEditStore } from "./WorkoutEditContext";

interface AssignSetAssignedValuesPayload {
  workoutSetId: string;
  exerciseAttributeId: string;
  assignedValue: string;
}

export function useAssignSetAssignedValues() {
  const workoutEditStore = useWorkoutEditStore();

  function assignSetAssignedValues(payload: AssignSetAssignedValuesPayload) {
    workoutEditStore.assignSetAssignedValues(
      payload.workoutSetId,
      payload.exerciseAttributeId,
      payload.assignedValue,
    );
  }

  return assignSetAssignedValues;
}
